module.exports = __webpack_public_path__ + "img/vote-icon.099172e9.jpg";